;(function( w ) {
  const initYouTubePlugin = jQuery('[data-youtube-url]').length > 0;
  if (!initYouTubePlugin) {
    return;
  }
  var tag = document.createElement('script');
	tag.src = "https://www.youtube.com/iframe_api";
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}(window));

window.onYouTubeIframeAPIReady = function(){
	window.YouTubeAPIReady = true;
	jQuery(window).trigger('YouTubeAPIReady');
}
